/**
 * NDG Hero — view.js (ES module)
 *
 * Initialise Embla Carousel sur le slider d'événements.
 * Chargé uniquement si le bloc ndg/hero est présent sur la page.
 */

import EmblaCarousel from 'embla-carousel';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

function initEventsSlider() {
	const viewports = document.querySelectorAll( '[data-hero-events-slider]' );
	if ( ! viewports.length ) return;

	viewports.forEach( ( viewport ) => {
		const embla = EmblaCarousel( viewport, {
			loop: false,
			align: 'start',
			dragFree: false,
			containScroll: 'trimSnaps',
		}, [ WheelGesturesPlugin( { forceWheelAxis: 'x' } ) ] );

		// Accessibilité clavier : navigation par touches fléchées
		viewport.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'ArrowRight' ) embla.scrollNext();
			if ( e.key === 'ArrowLeft' )  embla.scrollPrev();
		} );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initEventsSlider );
} else {
	initEventsSlider();
}
